import functions from '../../../../../world/spa/libs/vuexFunctions';

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldUser']),
        getByID: state => user => 
        {
            return state.objs.filter(u => u.idWorldUser === user);
        },
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldUser'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldUser'])
    },
}